module.exports = __webpack_public_path__ + "school/img/but.835e962c.jpg";